import { fromJS } from 'immutable';
import { FETCH_ADDRESS_SUCCESS, FETCH_ADDRESS_FAILED, SELECT_ADDRESS_SUCCESS } from './actions';
import { POST_CODE_LIST } from '../../utils/constants';
import { ON_CANCEL_EDIT_CLICK } from '../dataCapture';
const addressTypes = ['register', 'trading', 'mailing'];
export const initialState = fromJS({
  loading: false
});

export const SELECTED_ADDRESS = 'SelectedAddress';
export const POSTCODE_ERROR = 'postcode_error';

const defaultAddressState = {
  registerManuallyClickedValue: false,
  mailingpostcode_error: false,
  mailingManuallyClickedValue: false,
  tradingpostcode_error: false,
  registerpostcode_error: false,
  loading: false,
  tradingManuallyClickedValue: false,
  registerpostCodeAddressList: [],
  tradingpostCodeAddressList: [],
  mailingpostCodeAddressList: []
};

const MANUALLY_CLICKED = 'ManuallyClicked';
const addressReducer = (state = initialState, action) => {
  const key = getActionKey(action, FETCH_ADDRESS_SUCCESS);
  const key_fail = getActionKey(action, FETCH_ADDRESS_FAILED);
  const key_select_address = getActionKey(action, SELECT_ADDRESS_SUCCESS);
  const ADD_MANUALLY_TYPE = `${getActionKey(action, MANUALLY_CLICKED)}${MANUALLY_CLICKED}`;
  const ADDRESS_SUCCESS = `${key}${FETCH_ADDRESS_SUCCESS}`;
  const ADDRESS_FAIL = `${key_fail}${FETCH_ADDRESS_FAILED}`;
  const SELECT_ADD_SUCCESS = `${key_select_address}${SELECT_ADDRESS_SUCCESS}`;
  switch (action.type) {
    case ADDRESS_FAIL:
      return state
        .set(`${key_fail}${POST_CODE_LIST}`, [])
        .set(`${action.meta.key}ManuallyClickedValue`, false)
        .set(`${action.meta.key}${POSTCODE_ERROR}`, true);
    case ADDRESS_SUCCESS:
      return state
        .set(`${key}${POST_CODE_LIST}`, fromJS(getAddress(action)))
        .set(`${action.meta.key}${POSTCODE_ERROR}`, getAddress(action).length === 0)
        .set(`${key}ManuallyClickedValue`, false);
    case ADD_MANUALLY_TYPE:
      return state
        .set(`${ADD_MANUALLY_TYPE}Value`, action.data)
        .set(`${action.meta.key}${POSTCODE_ERROR}`, false);
    case SELECT_ADD_SUCCESS:
      return state.set(`${key_select_address}${SELECTED_ADDRESS}`, action.payload);
    case ON_CANCEL_EDIT_CLICK:
      return state.merge(defaultAddressState);
    default:
      return state;
  }
};

const getActionKey = (action, suffix) =>
  addressTypes.filter((v) => action.type === `${v}${suffix}`)[0];

const getAddress = (action) => {
  return action.payload.short_addresses
    ? action.payload.short_addresses
    : formatAddress(action.payload);
};

const formatAddress = (address) => {
  return [
    {
      id: address.id,
      potential_address: `${address.address_line1}, ${address.city}, ${address.postcode}`
    }
  ];
};
export default addressReducer;
